module.exports = __webpack_public_path__ + "static/bnr_square-a8507fa619a85761723755faeb06f3a0.webp";